import * as fs from 'fs';
import * as path from 'path';
import type { McqOtherInventoryRow } from './survey-inventory-extract';
import { formatMcqOtherTasksMarkdown, MCQ_OTHER_TASKS_FILENAME } from './survey-inventory-extract';

export function writeMcqOtherTasksFile(
  projectRoot: string,
  rows: McqOtherInventoryRow[],
  hasPickers: boolean,
): string {
  const tasksPath = path.join(projectRoot, MCQ_OTHER_TASKS_FILENAME);
  fs.writeFileSync(tasksPath, formatMcqOtherTasksMarkdown(rows, hasPickers), 'utf8');
  return tasksPath;
}
